import { render } from "./LazyProduct.vue?vue&type=template&id=14e3cc24&scoped=true"
import script from "./LazyProduct.vue?vue&type=script&lang=js"
export * from "./LazyProduct.vue?vue&type=script&lang=js"

import "./LazyProduct.vue?vue&type=style&index=0&id=14e3cc24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e3cc24"]])

export default __exports__